import { EPositionType, IEnrichedUniswapPosition } from '../types/uniswapTokens';

export const handleSortUniswapPositions = ({
  sortDesc, sortName, positions
}: {
  sortDesc: boolean,
  sortName: string,
  positions: IEnrichedUniswapPosition[],
}): IEnrichedUniswapPosition[] => {
  const resultPositions = sortDesc
    ? handleSortDesc(sortName, positions)
    : handleSortAsc(sortName, positions);
  return resultPositions.sort((a) => a.type === EPositionType.Pool ? 1 : -1);
};

const handleSortDesc = (
  sortName: string,
  positions: IEnrichedUniswapPosition[],
): IEnrichedUniswapPosition[] => {
  if (sortName === 'pool') {
    return positions.sort((a, b) => {
      const aSymbols = `${a.token0.symbol}${a.token1.symbol}`.toUpperCase();
      const bSymbols = `${b.token0.symbol}${b.token1.symbol}`.toUpperCase();
      return aSymbols.localeCompare(bSymbols);
    });
  }
  if (sortName === 'type') {
    return positions.sort((a, b) => {
      return a.poolType
        ? a.poolType.localeCompare(b.poolType || a.poolType)
        : -1;
    });
  }
  if (sortName === 'liquidity') {
    return positions.sort((a, b) => {
      return a.marketReferenceCurrencyValue - b.marketReferenceCurrencyValue;
    });
  }
  if (sortName === 'maxLeverage') {
    return positions.sort((a, b) => {
      return a.maxLeverage - b.maxLeverage;
    });
  }
  if (sortName === 'maxApr') {
    return positions.sort((a, b) => {
      const maxAprA = a.maxApr && (a.positionInRange || a.type === EPositionType.Pool) ? a.maxApr : 0;
      const maxAprB = b.maxApr && (b.positionInRange || b.type === EPositionType.Pool) ? b.maxApr : 0;
      return maxAprA - maxAprB;
    });
  }
  return positions;
};

const handleSortAsc = (
  sortName: string,
  positions: IEnrichedUniswapPosition[],
): IEnrichedUniswapPosition[] => {
  if (sortName === 'pool') {
    return positions.sort((a, b) => {
      const aSymbols = `${a.token0.symbol}${a.token1.symbol}`.toUpperCase();
      const bSymbols = `${b.token0.symbol}${b.token1.symbol}`.toUpperCase();
      return bSymbols.localeCompare(aSymbols);
    });
  }
  if (sortName === 'type') {
    return positions.sort((a, b) => {
      return b.poolType
        ? b.poolType.localeCompare(a.poolType || b.poolType)
        : -1;
    });
  }
  if (sortName === 'liquidity') {
    return positions.sort((a, b) => {
      return b.marketReferenceCurrencyValue - a.marketReferenceCurrencyValue;
    });
  }
  if (sortName === 'maxLeverage') {
    return positions.sort((a, b) => {
      return b.maxLeverage - a.maxLeverage;
    });
  }
  if (sortName === 'maxApr') {
    return positions.sort((a, b) => {
      const maxAprA = a.maxApr && (a.positionInRange || a.type === EPositionType.Pool) ? a.maxApr : 0;
      const maxAprB = b.maxApr && (b.positionInRange || b.type === EPositionType.Pool) ? b.maxApr : 0;
      return maxAprB - maxAprA;
    });
  }
  return positions;
};
